// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__11qVE","selected":"Chip_selected__3NQlp"};